import { Files } from "../../../../features/Files";
import { FilesPage } from "../../../../pages/FilesPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const userfilesPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.userfiles.root,
  element: <FilesPage />,
  name: "Файлы",
  children: appRouterPaths.userfiles.item
    ? [
        {
          path: appRouterPaths.userfiles.item,
          element: <Files />,
          name: "Файл",
        },
      ]
    : undefined,
};
